<template>
  <div class="loginContainer">
    <div>欢 迎 登 录</div>
    <p>学 生 成 长 档 案 管 理 平 台</p>
    <div class="img"></div>
    <div class="form">
      <input
        @focus="hideMark"
        @blur="showMark"
        type="text"
        placeholder="请输入学号"
        v-model.trim="form.username"
      />
      <input
        @focus="hideMark"
        @blur="showMark"
        type="password"
        placeholder="请输入密码"
        v-model="form.password"
      />
    </div>
    <div class="login" @click="login">登 录</div>
    <div class="trademark">西 安 鹏 迪 信 息 科 技 有 限 公 司</div>
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
export default {
  name: "Home",
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      openId: null
    };
  },
  mounted() {
    // this.authorizationLogin();
  },
  methods: {
    authorizationLogin() {
      const APPID = "wx34b83aa67c6337bf";
      const REDIRECT_URI = encodeURIComponent(config.REDIRECT_URI);
      const SCOPE = "snsapi_base";
      const STATE = "";
      const xToten = localStorage.getItem("x_token");
      if (xToten) {
        if (!location.search) {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&response_type=code&scope=${SCOPE}&redirect_uri=${REDIRECT_URI}&state=${STATE}#wechat_redirect`;
        } else if (location.search) {
          let tmpArr = location.search.split("?")[1].split("&");
          let obj = {};
          tmpArr.forEach(item => {
            obj[item.split("=")[0]] = item.split("=")[1];
          });
          const CODE = obj.code;
          this.$get(api.login.wxlogin(), { code: CODE }).then(res => {
            if (res.status === 1) {
              if (!res.data.token) {
                this.openId = res.data.openId;
              } else {
                localStorage.setItem("x_token", res.data.token);
                this.$toast({
                  message: "登录成功",
                  duration: 1000,
                  position: "bottom"
                });
                this.$router.push({
                  path: "/"
                });
              }
            } else {
              this.$toast({
                message: res.message,
                duration: 1000,
                position: "bottom"
              });
            }
          });
        }
      }
    },
    hideMark() {
      document.querySelector(".trademark").style.display = "none";
    },
    showMark() {
      document.querySelector(".trademark").style.display = "block";
    },
    login() {
      localStorage.removeItem("x_token");
      localStorage.removeItem("userCode");
      if (this.form.username === "") {
        this.$toast({
          message: "请输入学号",
          duration: 1000,
          position: "bottom"
        });
        return false;
      }
      if (this.form.password === "") {
        this.$toast({
          message: "请输入密码",
          duration: 1000,
          position: "bottom"
        });
        return false;
      }
      let formParams = new FormData();
      formParams.append("username", this.form.username);
      formParams.append("password", this.form.password);
      formParams.append("schoolname", "");
      this.$post(api.login.login(), formParams).then(res => {
        if (res.status === 1) {
          localStorage.setItem("x_token", res.data.token);
          localStorage.setItem("roleId", res.data.roles[0].code);
          if (this.form.password == "Admin123!") {
            this.$router.push({
              path: "/resetPassword"
            });
          } else {
            this.$toast({
              message: "登录成功",
              duration: 1000,
              position: "bottom"
            });
            localStorage.setItem("userCode", this.form.username);
            this.$router.push({
              path: "/"
            });
          }
        } else {
          this.$toast({
            message: res.message,
            duration: 1000,
            position: "bottom"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.loginContainer {
  // box-sizing: border-box;
  padding: 199px 50px 0 48px;
  background-color: #fff;
  // width: 100vw;
  // overflow: hidden;
  > div:first-of-type {
    height: 58px;
    font-size: 60px;
    font-family: "PingFangSC";
    font-weight: 600;
    color: rgba(50, 50, 50, 1);
  }
  > p {
    height: 31px;
    font-size: 32px;
    font-family: PingFangSC;
    font-weight: 600;
    color: rgba(50, 50, 50, 1);
    margin-top: 36px;
  }
  > .img {
    width: 197px;
    height: 213px;
    position: absolute;
    top: 156px;
    right: 50px;
    background-image: url("../../assets/touxiang.png");
    background-size: 100% 100%;
  }
  .form {
    margin-top: 220px;
    input {
      width: 100%;
      padding-bottom: 30px;
      padding-left: 10px;
      border: 0;
      border-bottom: 2px solid rgba(238, 238, 238, 1);
      letter-spacing: 3px;
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #323232;
      &:last-of-type {
        margin-top: 121px;
      }
      &::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #ccc;
        /* placeholder字体大小  */
        font-size: 30px;
        /* placeholder位置  */
        text-align: left;
      }
    }
  }
  .login {
    height: 100px;
    width: 100%;
    line-height: 100px;
    text-align: center;
    margin-top: 120px;
    @include linear-gradient(
      rgba(142, 233, 202, 1) 0%,
      rgba(3, 177, 135, 1) 100%
    );
    font-size: 30px;
    font-family: PingFangSC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    border-radius: 50px;
    box-shadow: 0px 0px 30px 0px rgba(156, 233, 200, 0.6);
  }
  .trademark {
    height: 20px;
    font-size: 20px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(221, 221, 221, 1);
    text-align: center;
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
